import { render, staticRenderFns } from "./InspectionDetailPage.vue?vue&type=template&id=5cf07a00&"
import script from "./InspectionDetailPage.vue?vue&type=script&lang=ts&"
export * from "./InspectionDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports